import React, {ReactNode} from 'react';
import {View, ViewStyle} from 'react-native';
import {isFunction} from 'lodash/fp';

import Text from '/component/base/Text';

import {styles} from './ScreenSection.style';

interface ScreenSectionProps {
  style: {
    base?: ViewStyle;
    heading?: ViewStyle;
    content?: ViewStyle;
  };
  children: ReactNode;
  title: ReactNode | (() => ReactNode);
}

export const ScreenSection: React.FC<ScreenSectionProps> = ({
  style: styleProp = {},
  children = null,
  title = '',
}) => {
  const style = [styles.base, styleProp.base];
  const headingStyle = [styles.heading, styleProp.heading];
  const contentStyle = [styles.content, styleProp.content];

  return (
    <View style={style}>
      <View style={headingStyle}>
        {isFunction(title) ? title() : <Text>{title}</Text>}
      </View>
      <View style={contentStyle}>{children}</View>
    </View>
  );
};

export default ScreenSection;
